import React from "react";

const IssuerCompanyCard = ({ company, selected, onSelect }) => {
	const isAfecta = company.tipoTributario === "afecta";

	return (
		<div
			className="cell small-12 medium-6"
			style={{ marginBottom: "16px" }}
		>
			<div
				style={{
					border: selected ? "2px solid #1779ba" : "1px solid #cbd5e0",
					borderRadius: "8px",
					padding: "16px",
					background: "#fff",
					height: "100%",
					boxShadow: selected ? "0 0 0 3px rgba(23,121,186,0.15)" : "none",
				}}
			>
				<div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
					<div
						style={{
							width: "56px",
							height: "56px",
							borderRadius: "8px",
							backgroundColor: company.logoColor || "#2c3840",
							color: "#fff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontWeight: 700,
							fontSize: "18px",
							flexShrink: 0,
						}}
					>
						{company.logo || "DN"}
					</div>
					<div>
						<strong>{company.nombreFantasia || company.nombreLegal}</strong>
						<div style={{ fontSize: "13px", color: "#4a5568" }}>
							{company.nombreLegal}
						</div>
						<div style={{ fontSize: "13px" }}>RUT: {company.rut}</div>
					</div>
				</div>

				<div
					style={{
						marginTop: "12px",
						padding: "8px 10px",
						borderRadius: "6px",
						background: isAfecta ? "#ebf8ff" : "#f0fff4",
						color: isAfecta ? "#2b6cb0" : "#276749",
						fontWeight: 600,
						fontSize: "13px",
					}}
				>
					{isAfecta ? "Empresa afecta a IVA" : "Empresa exenta de IVA"}
				</div>

				<button
					type="button"
					className="button primary"
					style={{ marginTop: "12px", marginBottom: 0, width: "100%" }}
					onClick={() => onSelect(company)}
				>
					{selected ? "Seleccionada" : "Seleccionar"}
				</button>
			</div>
		</div>
	);
};

export default IssuerCompanyCard;
